import React from "react"
import { useQuery } from "@tanstack/react-query"
import { FormattedMessage } from "react-intl"
import { useDispatch, useSelector } from "react-redux"

import DocViewer from "@cyntler/react-doc-viewer";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { addCVFile } from "../../../redux/slices/cvSlice"
import { getCVFile } from "../../../services/cv"

import { Spinner } from "../../common";

const useFetchCVFile = ({id, enabled}) => {
  const dispatch = useDispatch();

  const { data, isFetching } = useQuery({
    queryKey: ["cvFile", id],
    queryFn: () => getCVFile(id),
    enabled,
    gcTime: 3_600_000, // 1 hour
  });

  const url = data?.url;
  if (enabled && !isFetching && url) {
    dispatch(addCVFile({ id, url }));
  }

  return { fetchedUrl: url, loading: isFetching };
}

const CVFile = ({ id, url: urlProp }) => {
  const sliceCVUrl = useSelector((state) => state.cv.cvsFiles[id]);

  const { fetchedUrl, loading } = useFetchCVFile({
    id,
    enabled: Boolean(!urlProp && id && !sliceCVUrl),
  });

  const cvUrl = urlProp || sliceCVUrl || fetchedUrl;

  if (loading) return <Spinner />;

  if (!cvUrl) {
    return (
      <h3 id="cv-not-found">
        <FormattedMessage id="error.cvFileNotFound" />
      </h3>
    );
  }

  const isPdf = cvUrl.includes(".pdf?")

  return (
    <div className="cv-render">
      <DocViewer
        config={{
          header: {
            disableHeader: true,
            
          },
        }}
        style={{ minHeight: 800 }}
        theme={{}}
        documents={[
          {
            uri: cvUrl,
            fileType: isPdf
              ? "application/pdf"
              : "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          },
        ]}
      />
    </div>
  )
}

export default CVFile
